import { Component, OnInit } from '@angular/core';
import {
  Event,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router
} from '@angular/router';

import { HelpersService , HeaderService, MainSidebarService} from '@base/shared/services';

import { delay } from 'rxjs/operators';

@Component({
  selector: 'app-base-view',
  templateUrl: './base-view.component.html',
  styleUrls: ['./base-view.component.sass']
})
export class BaseViewComponent implements OnInit {

  public loading: Boolean = false;
  public sidebarOpened = false;
  public panelToggle = false;

  constructor(
    private router: Router,
    private headerService: HeaderService,
    private mainSidebarService: MainSidebarService,
  ) { }

  ngOnInit() {
    this.subscribeToRouter();


    this.headerService.panelOpen.subscribe(() => {
      this.sidebarOpened = !this.sidebarOpened;
    });

    this.headerService.panelClose.subscribe(() => {
      this.sidebarOpened = !this.sidebarOpened;
    });

    this.mainSidebarService.toggleSidebarCollapsed.subscribe(() => {
      this.panelToggle = !this.panelToggle;
    });

  }

  /**
   * Listen router events to know when to show the
   * loading progress bar
   */
  private subscribeToRouter() {
    this.router.events
      .pipe(
        delay(50)
      )
      .subscribe((event: Event) => {
        switch (true) {
          case event instanceof NavigationStart: {
            this.loading = true;
            break;
          }

          case event instanceof NavigationEnd:
          case event instanceof NavigationCancel:
          case event instanceof NavigationError: {
            this.loading = false;
            break;
          }
          default: {
            break;
          }
        }
      });
  }
}
